import api from "lib/api";
import apiFormData from "lib/apiFormData";

export const fetchCompany = async () => {
  return await api.post("/v1/dropdown/getCompanyByUser");
};

export const getCompany = async (params = {}) => {
  return await api.post("/v1/company/getCompany", params);
};

export const createCompany = async (params = {}) => {
  return await apiFormData.post("/v1/company/createCompany", params, {
    isFormData: true,
  });
};

// export const getWorkingCondition = async (params = {}) => {
//   return await api.post("/v1/workingCondition/getWorkingCondition", params);
// };

export const rolePermissionByEmpId = async (params = {}) => {
  return await api.post("/v1/dropdown/rolePermissionByEmpId", params);
};

export const editCompany = async (params = {}) => {
  return await apiFormData.post("/v1/company/updateCompany", params, {
    isFormData: true,
  });
};

export const getWorkingCondition = async (params = {}) => {
  return await api.post("/v1/workingCondition/getWorkingCondition", params);
};

export const addWorkingCondition = async (params = {}) => {
  return await api.post("/v1/workingCondition/createWorkingCondition", params);
};

export const editWorkingCondition = async (params = {}) => {
  return await api.post("/v1/workingCondition/updateWorkingCondition", params);
};

export const getOvertimeCondition = async (params = {}) => {
  return await api.post("/v1/overtimeCondition/getOvertimeCondition", params);
};

export const addOvertimeCondition = async (params = {}) => {
  return await api.post(
    "/v1/overtimeCondition/createOvertimeCondition",
    params
  );
};

export const editOvertimeCondition = async (params = {}) => {
  return await api.post(
    "/v1/overtimeCondition/updateOvertimeCondition",
    params
  );
};

export const compressedImage = async (params = {}) => {
  return await apiFormData.post(
    "/v1/image/compressedImage",
    params,
    {
      responseType: 'blob'
    }
  );
};

export const changeCompanyTheme = async (params = {}) => {
  return await api.post(
    "/v1/company/changeTheme",
    params
  );
};

export const updateFcmToken = async (params = {}) => {
  return await api.post(`/v1/notification/updateFcmToken`, params);
};




